import _ from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrMessages } from 'src/app/utils/errorHandler';
import { removeToken, setToken } from 'src/app/services/localStorage';
import { showMessage } from '../core/messageSlice';

export const handleLogin = createAsyncThunk(
  'auth/login',
  async ({ _request, props = [] }, { dispatch, rejectWithValue }) => {
    if (typeof _request !== 'function') {
      const errorMessage = '_request must be a function';
      console.error(errorMessage);
      return rejectWithValue({ errors: [errorMessage] });
    }
    try {
      const response = await _request(...props);
      const { data } = await response;
      const token = data.access_token || null;
      const tokenType = data?.token_type;
      const fulfilledRes = {
        ..._.omit(data, ['access_token', 'token_type']),
        token,
        tokenType,
      };

      if (tokenType === 'Bearer') {
        setToken(token);
      }
      return fulfilledRes;
    } catch (error) {
      const errArray = getErrMessages(error);
      const message = errArray.join();
      dispatch(showMessage({ message }));
      console.log(errArray);
      return rejectWithValue(errArray);
    }
  }
);

export const handleLogout = createAsyncThunk(
  'auth/logout',
  async ({ _request, props = [] }, { dispatch, rejectWithValue }) => {
    if (typeof _request !== 'function') {
      const errorMessage = '_request must be a function';
      console.error(errorMessage);
      return rejectWithValue({ errors: [errorMessage] });
    }
    try {
      const response = await _request(...props);
      dispatch(showMessage({ message: 'La sesión se ha finalizado correctamente' }));
      const logoutData = response?.data;
      return { logoutData };
    } catch (error) {
      const errArray = getErrMessages(error);
      const message = errArray.join();
      dispatch(showMessage({ message }));
      return rejectWithValue(errArray);
    } finally {
      removeToken();
    }
  }
);

export const handleResolveMagicXchg = createAsyncThunk(
  'auth/resolveTknRedirect',
  async ({ _request, props = [] }, { dispatch, rejectWithValue }) => {
    if (typeof _request !== 'function') {
      const errorMessage = '_request must be a function';
      console.error(errorMessage);
      return rejectWithValue({ errors: [errorMessage] });
    }
    try {
      const response = await _request(...props);
      const { data } = await response;
      const token = data.access_token || null;
      const tokenType = data?.token_type;
      const fulfilledRes = {
        ..._.omit(data, ['access_token', 'token_type']),
        token,
        tokenType,
      };

      if (tokenType === 'Bearer') {
        setToken(token);
      }
      return fulfilledRes;
    } catch (error) {
      removeToken();
      const errArray = getErrMessages(error);
      const message = errArray.join();
      dispatch(showMessage({ message }));
      console.log(errArray);
      return rejectWithValue(errArray);
    }
  }
);
